module.exports = __webpack_public_path__ + "static/media/workprocess2.83873d14.png";